import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mapfre-auditlib-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnChanges {

  public show = [];
  @Input() menu;
  @Input() title;
  @Output() itemClicked = new EventEmitter();

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnChanges(change: SimpleChanges) {
    if (change.menu.currentValue && change.menu.currentValue.length > 0) {
      //  this.prepareActions(this.menu);
    }
  }

  onItemClicked(event) {
    this.itemClicked.emit(event);
  }



}
